<template>
  <div class="content-wrapper">
    <!-- <h1>Site List</h1> -->
    <app-overlay-loader v-if="preloader" />
    <!-- pdf-orientation="landscape" --> 
    <div class="card card-with-shadow border-0 h-100 employee-preview-card">
      <div class="card-body position-relative d-flex flex-column">
        <VueHtml2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="myPDF"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-content-width="100%"
          ref="html2Pdf">
          <section slot="pdf-content">
            <div v-if="Object.keys(site).length == 0">
                  <app-empty-data-block :message="$t('nothing_to_show_message')" />
            </div>
            <div v-else>
              <div class="d-flex flex-column">
                <div style="text-align: end" v-if="hideOnPrint == true">
                  <el-tooltip
                    v-if="isNotCustomer"
                    placement="top"
                    :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                    :content="$t('edit_site_detail')">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      data-toggle="modal"
                      @click="openSiteEditModal">
                      {{ $t("edit_site") }}
                    </button>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                    :content="$t('attach_document_detail')">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        @click="openAttachDocumentModal">
                        {{ $t("attach_generated_documnent") }}
                      </button>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                    :content="$t('assign_user_detail')">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        @click="openAssignUserModal">
                        {{ $t("assign_user") }}
                      </button>
                  </el-tooltip>
                  <el-tooltip
                    placement="top"
                    :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                    :content="$t('print_detail')">
                    <button
                      type="button" 
                      @click.prevent="generateReport" 
                      class="btn btn-primary btn-sm">Print</button>
                  </el-tooltip>
                  
                </div>
                <h5
                  class="mb-3 mt-3"
                  style="font-size: 1.15rem; color: var(--job-title-color)"
                >
                  {{ site[0].title }}
                </h5>
                <!-- <small class="mb-3"> ({{ profile.job_type }}) </small> -->

                <p class="mb-3 font-size-90">{{ site[0].description }}</p>
                <div class="row">
                  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <p class="mb-3">
                      <b>{{ $t("assignment_structure") }}</b
                      ><br />
                      {{ site[0].assignment_structure }}
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <p class="mb-3">
                      <b>{{ $t("site_address") }}</b
                      ><br />
                      {{ site[0].site_address }}
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <p class="mb-3">
                      <b>{{ $t("site_info") }}</b
                      ><br />
                      {{ site[0].site_info }}
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <p class="mb-3">
                      <b>{{ $t("start_time") }}</b
                      ><br />
                      {{ site[0].starting_hours }}
                    </p>
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                    <p class="mb-2">
                      <b>{{ $t("end_time") }}</b> <br />
                      {{ site[0].ending_hours }}
                    </p>
                  </div>
                </div>

                <!-- <p class="mb-2">
              {{ $t("job_type") + ": " + profile.job_type }}
            </p> -->
                <!-- <div v-if="profile.status" class="my-3">
              <span
                :class="
                  'badge badge-sm badge-pill badge-' + statusClass(profile.status)
                "
                >{{ profile.status }}</span
              >
            </div> -->
                <!-- <p v-if="profile.phone" class="mb-2">{{ profile.phone }}</p>
            <p v-if="profile.gender" class="mb-2">{{ $t(profile.gender) }}</p>
            <p v-if="profile.age" class="mb-2">
              {{ $t("age") + ": " + profile.age }}
            </p> -->
              </div>
              <div class="d-flex flex-column">
                  <div style="text-align: end" v-if="hideOnPrint == true">
                    <el-tooltip
                      placement="top"
                      :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('add_task_detail')">

                      <button
                        v-if="site[0].type == 1"
                        type="button"
                        class="btn btn-primary btn-sm mb-2"
                        data-toggle="modal"
                        @click="openTaskAddModal()">
                        {{ $t("add_task") }}
                      </button> 
                    </el-tooltip>
                    
                    <el-tooltip
                      placement="top"
                      :effect="themeMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('site_induction_tasks_detail')">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm mb-2"
                        data-toggle="modal"
                        @click="openSiteViewModal()">
                        {{ $t("site_induction_tasks") }}
                      </button>
                    </el-tooltip>
                      
                  </div>
                </div>

              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div
                    style="text-align: end; justify-content: space-between"
                    class="d-flex"
                  >
                    <label>{{ $t("user_list") }}</label>
                    <!-- <button
                      type="button"
                      class="btn btn-primary btn-sm mb-2"
                      data-toggle="modal"
                      @click="openTaskAddModal()"
                    >
                      {{ $t("add_task") }}
                    </button> -->
                  </div>
                  <app-table :id="tableId" :options="options" @action="getListAction" />
                </div>
              </div>
            </div>
          </section>
        </VueHtml2pdf>
      </div>
    </div>
    
    <myjob-site-attach-documentmodal
      :id="site[0].id"
      v-if="isAttachDocumentModalActive"
      @close-modal="closeModal"
    />
    <job-site-assign-usermodal
      :id="site[0].id"
      v-if="isAssignUserModalActive"
      @close-modal="closeAssignUserModal"
    />
    <task-mytaskmodal
      v-if="isMYTASKModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeTaskModal"
      :id="taskId"
    />
    <site-editmodal
      :id="site[0].id"
      :siteRefresh="getSite"
      v-if="isSiteEditModalActive"
      @close-modal="closeSiteEditModal"
    />
    <mysite-viewmodal
      v-if="isSiteViewModalActive"
      :id="site[0].id"
      :url='taskUrl'
      :type='`private`'
      @close-modal="closeSiteViewModal"/>
    <!-- <site-taskeditmodal
      :getSite="getSite"
      :id="taskId"
      :title="title"
      v-if="isTaskEditModalActive"
      @close-modal="closeTaskEditModal"
    /> -->
    <site-taskaddmodal
      :getSite="getSite"
      :siteid="site[0].id"
      :selected-url="selectedUrl"
      v-if="isTaskAddModalActive"
      @close-modal="closeTaskAddModal"
    />
  </div>
</template>

<script>
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import {
  COMPANY_JOB_SITE_SHOW,
  COMPANY_JOB_SITE_SHOW_LIST,
  COMPANY_JOB_UPDATE,
  GET_SITE_USER_ASSIGNED_LIST,
  COMPANY_JOB_USERS_WITH_TASK,

} from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";
// import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  name: "List",
  // taskid: 0,
  //   components: { CopyButton },
  props: {
    id: Number,
  },
  data() {
    return {
      isNotCustomer: true,
      hideOnPrint: true,
      title:'',
      selectedUrl: "",
      siteId: this.id,
      taskId: "",
      site: {},
      isSiteViewModalActive: false,
      isSiteEditModalActive: false,
      isTaskEditModalActive: false,
      isTaskAddModalActive: false,
      isMYTASKModalActive:false,
      isAttachDocumentModalActive: false,
      isAssignUserModalActive: false,
      preloader: true,
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: COMPANY_JOB_USERS_WITH_TASK,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("users"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span>${this.$t(value.full_name)}</span>`;
            },
          },
          {
            title: this.$t("task_completed"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span><b>${value.completed}<b></span>`;
            },
          },
          // // {
          // //     title: this.$t('assigned_to'),
          // //     type: 'custom-html',
          // //     key: 'assigned_to',
          // //     modifier: (value) => {
          // //         return `<span>${this.$t(value)}</span>`
          // //     }
          // // },
          {
            title: this.$t("task_incompleted"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span><b>${value.incompleted}<b></span>`;
            },
          },
          // {
          //   title: this.$t("due_date_&_time"),
          //   type: "custom-html",
          //   key: "due_date",
          //   modifier: (value, row) => {
          //     let end_time = moment(row.end_time, ["h:mm"]).format("h:mm A");
          //     return `<span>${this.$t(value)}</span><br><span>${this.$t(end_time)}</span>`;
          //   },
          // },
          // {
          //   title: this.$t("priority"),
          //   type: "custom-html",
          //   key: "priority",
          //   modifier: (value) => {
          //     let ClassName = "danger";

          //     if (value === "low") ClassName = `success`;
          //     else if (value === "medium") ClassName = `warning`;
          //     else if (value === "high") ClassName = `danger`;
          //     return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
          //       value
          //     )}</span>`;
          //   },
          // },
          // {
          //   title: this.$t("status"),
          //   type: "custom-html",
          //   key: "status",
          //   isVisible: true,
          //   modifier: (value) => {
          //     let ClassName = "danger";

          //     if (value === "completed") ClassName = `success`;
          //     else if (value === "incomplete") ClassName = `warning`;
          //     else if (value === "action_required") {
          //       ClassName = `info`; value = 'Action Required';}

          //     return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
          //       value
          //     )}</span>`;
          //   },
          // },
        ],
        // actions: [
        //   // {
        //   //   title: this.$t("edit"),
        //   //   icon: "edit",
        //   //   type: "none",
        //   //   component: "app-add-modal",
        //   //   modalId: "demo-add-edit-Modal",
        //   // },
        //   // {
        //   //     title: this.$t('delete'),
        //   //     icon: 'trash',
        //   //     type: 'none',
        //   //     component: 'app-confirmation-modal',
        //   //     modalId: 'demo-delete',
        //   // },
        //   {
        //     title: this.$t("view"),
        //     icon: "eye",
        //     type: "none",
        //     component: "app-add-modal",
        //     modalId: "demo-add-edit-Modal",
        //   },
        // ],
        filters: [
          // {
          //   title: this.$t("date"),
          //   type: "range-picker",
          //   key: "date",
          //   option: ["today", "thisMonth", "last7Days", "nextYear"],
          // },
          // {
          //   title: this.$t("priority"),
          //   type: "checkbox",
          //   key: "priority",
          //   option: [
          //     { id: "low", value: "Low" },
          //     { id: "medium", value: "Medium" },
          //     { id: "high", value: "High" },
          //   ],
          // },
          // {
          //   title: this.$t("status"),
          //   type: "checkbox",
          //   key: "status",
          //   option: [
          //     { id: "completed", value: "Completed" },
          //     { id: "incomplete", value: "Incomplete" },
          //     // {id: 'invited', value: 'Invited'},
          //   ],
          // },
          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: false,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 3,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    // this.options.columns = [...this.options.columns, this.actionObj];
    this.options.columns = [...this.options.columns];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    generateReport() {
      this.hideOnPrint = false;
      this.$refs.html2Pdf.generatePdf();
    },
    openSiteViewModal() {
      this.$store.commit('updateSharedData', {index: "siteData", newValue: this.site[0]})

      this.taskUrl = COMPANY_JOB_SITE_SHOW_LIST;
      this.isSiteViewModalActive = true;

    },
    closeSiteViewModal() {
      $("#demo-site-view-Modal").modal("hide");
      this.isSiteViewModalActive = false;
    },
    openAssignUserModal() {
      this.isAssignUserModalActive = true;
    },
    closeAssignUserModal() {
      $("#demo-assign-user-Modal").modal("hide");
      this.isAssignUserModalActive = false;
    },
    openAttachDocumentModal() {
      this.isAttachDocumentModalActive = true;
    },
    closeModal() {
      $("#demo-attach-document-Modal").modal("hide");
      this.isAttachDocumentModalActive = false;
    },
    openTaskViewModal(taskid) {
      this.taskId = taskid;
      this.isMYTASKModalActive = true;
    },
    closeTaskModal() {
      $("#demo-assign-user-Modal").modal("hide");
      this.isMYTASKModalActive = false;
    },
    openSiteEditModal() {
      this.isSiteEditModalActive = true;
    },
    // openTaskEditModal(id) {
    //   // this.taskid = id;
    //   // this.selectedUrl = `${COMPANY_JOB_SITE_TASK_SHOW}/${id}`;
    //   this.taskId = id;
    //   this.title = 'Site Task';
    //   this.isTaskEditModalActive = true;
    // },
    openTaskAddModal() {
      $("#demo-task-add-Modal").modal("show");
      this.isTaskAddModalActive = true;
    },

    /**
     * for close add edit modal
     */
    closeSiteEditModal() {
      // $("#demo-add-edit-Modal").modal("hide");
      this.isSiteEditModalActive = false;
      // this.reSetData();
    },
    closeTaskAddModal() {
      $("#demo-task-add-Modal").modal("hide");
      this.isTaskAddModalActive = false;
      // this.reSetData();
    },
    // closeTaskEditModal() {
    //   // $("#my_task_modal").modal("hide");
    //   this.isTaskEditModalActive = false;
    //   this.selectedUrl = "";
    // },
    getListAction(rowData, actionObj, active) {
     if (actionObj.title == this.$t("view")) {
        this.openTaskViewModal(rowData.id); 
      }
    },
    getSite() {
      axiosGet(COMPANY_JOB_SITE_SHOW + "/" + this.id)
        .then((res) => {
          this.preloader = true;
          this.site = res.data;
          this.innerId = this.id;
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getSiteUsersWitthTasks() {
      this.options.url = COMPANY_JOB_USERS_WITH_TASK +'/'+ this.id;
      this.$hub.$emit("reload-" + this.tableId);
    },
    searchAndSelectFilterOptions() {
      axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.id).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
    customerAction() {
      let role = this.userRole.role;
      if (role == "Customer" || role == "customer") {
        this.isNotCustomer = false;
      }
    },
  },
  mounted() {
    this.getSite();
    console.log(this.id);
    // this.getSiteTasks();
    this.customerAction();
  },
  watch: {
    id: function (newVal, oldVal) {
      this.getSite();
      this.getSiteUsersWitthTasks();
      this.searchAndSelectFilterOptions();
    },
  },
   computed: {
    themeMode() {
      return this.$store.state.theme;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>